import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TablePagination } from "../../../../../common/details-table/table-pagination.component";
import { AUDIT_KEY, AUDIT_EXCEPTION, AUDIT_RULES, DEFAULT_PAGE_VALUE, ROUTE_LINK_LOCATION, TABLE_PAGINATION_KEY, TABLE_WARNING_ICON, CIRCUIT_NOT_FOUND, GDPR_CONFIRMATION_MESSAGE } from "../../../../../../constants/external-constants";
import ButtonIcon from "../../../../../button";
import { invoiceAuditRulesActions } from "../../../../../../store/external/invoice/invoice/audit-table.reducer";
import Translation from '../../../../../common/translation/translation.component';
class AuditTable extends Component {
    constructor(props) {
        super(props);
        this.state={
            displaySearch: false,
            exportAlertMsg: GDPR_CONFIRMATION_MESSAGE.exportAlertMsg,
        }
    }
    componentDidMount() {
        const { invoiceDetailsId, getInvoiceAuditRules } = this.props;
        getInvoiceAuditRules(invoiceDetailsId, 0);
    }
    componentWillUnmount() {
        this.props.resetInvoiceAuditRules();
    }
    onGetInvoiceAuditRules = (pageIndex) => {
        const { invoiceDetailsId, getInvoiceAuditRules } = this.props;
        getInvoiceAuditRules(invoiceDetailsId, pageIndex);
    }
    onColumnSearchAuditRules = () => {
        const { invoiceDetailsId, getInvoiceAuditRules } = this.props;
        getInvoiceAuditRules(invoiceDetailsId, 0);
    }
    onColumnSortAuditRules = (columnClicked, isSortedAsc) => {
        const { invoiceDetailsId, sortInvoiceAuditRules } = this.props;
        sortInvoiceAuditRules(columnClicked, isSortedAsc, invoiceDetailsId);
    }
    resizePage = (value) => {
        const { invoiceDetailsId, resizeAuditRulesPage, getInvoiceAuditRules } = this.props;
        resizeAuditRulesPage(value);
        getInvoiceAuditRules(invoiceDetailsId, 0);
    }
    onClickExtractAuditRules = () => {
        const { invoiceDetailsId, extractInvoiceAuditRules } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractInvoiceAuditRules(invoiceDetailsId);
        }
    }
    rowAction = (type, item, hasLink) => {

        if (type === AUDIT_KEY.DisputeCode && hasLink) {
                if(item.DisputeCode !== "" && item.DisputeCode !== null) {
                    window.open(`${ROUTE_LINK_LOCATION.invoiceDisputeDetailsLink}/${item.DisputeId}`, "_blank")
                }
                else {
                    if (item.AuditRulesResultsStatusName === "Valid") {
                        window.open(`${ROUTE_LINK_LOCATION.invoiceDisputeCreateNewLink}`, "_blank")
                    }
                    else {
                        this.props.handleShowExceptionModal(this.auditRulesExceptionTitle(item.AuditRulesException), item.InvoiceAuditID, item.AuditRulesExceptionId, item.AuditRulesResultsStatusInvalidFlag, item.AuditRulesResultsStatusId, item.AdditionalInformation);
                    }
                }
        } 
        else if (type === AUDIT_KEY.MatchedCircuitCode && hasLink) {
            if (item.MatchedCircuitCode !== CIRCUIT_NOT_FOUND.circuitNotFound && item.AuditRulesException !== AUDIT_EXCEPTION.invoicePercent) {
                window.open(`${ROUTE_LINK_LOCATION.circuitRouteLink}/${item.MatchedCircuitId}`, "_blank")
            }
            else {
                this.props.handleShowExceptionModal(this.auditRulesExceptionTitle(item.AuditRulesException), item.InvoiceAuditID, item.AuditRulesExceptionId, item.AuditRulesResultsStatusInvalidFlag, item.AuditRulesResultsStatusId, item.AdditionalInformation);
            }
        }
        else {
            this.props.handleShowExceptionModal(this.auditRulesExceptionTitle(item.AuditRulesException), item.InvoiceAuditID, item.AuditRulesExceptionId, item.AuditRulesResultsStatusInvalidFlag, item.AuditRulesResultsStatusId, item.AdditionalInformation);
        }
    }
    auditRulesExceptionTitle(exception){
        let headerName;
        switch (exception) {
            case AUDIT_EXCEPTION.circuitNotFound:
                headerName = <Translation translationKey='circuit_not_found' />
                break;
            case AUDIT_EXCEPTION.billingAccountMismatch:
                headerName = <Translation translationKey='billing_account_mismatch' />
                break;
            case AUDIT_EXCEPTION.ceasedButCharging:
                headerName = <Translation translationKey='ceased_but_charging' />
                break;
            case AUDIT_EXCEPTION.costAllocationNotFound:
                headerName = <Translation translationKey='cost_allocation_not_found' />
                break;
            case AUDIT_EXCEPTION.firstBill:
                headerName = <Translation translationKey='first_bill' />
                break;
            case AUDIT_EXCEPTION.invoicePercent:
                headerName = <Translation translationKey='invoice_percent' />
                break;
            case AUDIT_EXCEPTION.mrcMismatch:
                headerName = <Translation translationKey='mrc_mismatch' />
                break;
            case AUDIT_EXCEPTION.unbilledCircuit:
                headerName = <Translation translationKey='unbilled_circuit' />
                break;
            default:
                headerName = <Translation translationKey='circuit_not_found' />
                break;
        }
        return headerName
    }

    displaySearchField = () =>{
        this.setState({displaySearch:!this.state.displaySearch})
    }

    render(){
        const { handleExceptionModal, invoiceAuditRules, setInvoiceAuditRulesColSearchStr, isReadAndWrite, isReadOnly } = this.props;
        return(
            <div className="audit-table">
            <div className="button-header__alignment">
                    <ButtonIcon
                        onClick={isReadAndWrite ? () => { handleExceptionModal() } : () => { }}
                        iconLeft="check" iconSize="17px"
                        customClassName={`${isReadAndWrite ? "header-option-list" : ""} header-filter-button` }
                        labelName="Match / Audit"
                        isDisable={!isReadAndWrite}
                    />
                    <ButtonIcon onClick={() => { this.displaySearchField()}} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Search"/>

                    <ButtonIcon
                        onClick={!isReadOnly ? this.onClickExtractAuditRules : () => { }}
                            iconLeft="cloud-arrow-down" iconSize="17px"
                            customClassName={`${!this.props.isReadOnly ? "header-option-list" : ""} header-filter-button`}
                            isDisable={isReadOnly}
                            labelName="Extract List"
                    />
            </div>
            
               {
                    invoiceAuditRules && invoiceAuditRules.isInvoiceAuditRulesLoaded ?
                        <TablePagination
                        key={TABLE_PAGINATION_KEY.invoiceInvoice}  
                        classNameWrapper="overflow-auto" 
                        columns={invoiceAuditRules.invoiceAuditRulesItems.Headers}
                        pageList={invoiceAuditRules.invoiceAuditRulesItems.Data}
                        pages={invoiceAuditRules.invoiceAuditRulesItems.Pagination}
                        rowClickAction={(type, item, hasLink) => { this.rowAction(type, item, hasLink) }}
                        paginationAction={this.onGetInvoiceAuditRules}
                        onColumnClick={this.onColumnSortAuditRules}
                        onColumnSearch={() => { this.onColumnSearchAuditRules() }}
                        onColumnSearchChange={setInvoiceAuditRulesColSearchStr}
                        isColSearchShow={this.state.displaySearch}
                        resizePage={this.resizePage}
                        totalPage={invoiceAuditRules.invoiceAuditRulesItems.Pagination.TotalEntries}
                        columnFormatRendering={
                            {
                                'DisputeCode': {
                                propName:"DisputeCode", 
                                createLinkText: "Create Dispute",
                                isLink: true 
                                }
                            }
                        }
                        warningIconConfig={TABLE_WARNING_ICON.AUDIT_TABLE}
                        />  : null         
                }
           
           </div> 
        )
    }
}

export default connect(
    state => {
        const { invoiceAuditRules } = state;

        return {
            invoiceAuditRules
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceAuditRulesActions),
        dispatch
    )
)(AuditTable);
